import { render, staticRenderFns } from "./trainingDetail.vue?vue&type=template&id=af254e22&scoped=true"
import script from "./trainingDetail.vue?vue&type=script&lang=js"
export * from "./trainingDetail.vue?vue&type=script&lang=js"
import style0 from "./trainingDetail.vue?vue&type=style&index=0&id=af254e22&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af254e22",
  null
  
)

export default component.exports